import React, { useState } from 'react';
import { ThumbsUp, ThumbsDown } from 'lucide-react';
import toast from 'react-hot-toast';
import { submitPageFeedback } from '../services/featureDb';

interface Props {
  forumId: string;
  darkMode: boolean;
}

const HelpfulFeedback: React.FC<Props> = ({ forumId, darkMode }) => {
  const [done, setDone] = useState(() => !!localStorage.getItem(`feedback_${forumId}`));
  const [submitting, setSubmitting] = useState(false);

  const vote = async (helpful: boolean) => {
    if (submitting) return;
    setSubmitting(true);
    const { ok, error } = await submitPageFeedback(forumId, helpful);
    setSubmitting(false);
    if (ok) {
      setDone(true);
      toast.success('Geri bildiriminiz için teşekkürler');
    } else {
      toast.error(error || 'Gönderilemedi, lütfen tekrar deneyin');
    }
  };

  if (done) {
    return (
      <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
        Geri bildiriminiz için teşekkürler.
      </p>
    );
  }

  return (
    <div className="flex flex-wrap items-center gap-3">
      <span className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Bu sayfa faydalı mı?</span>
      <button
        type="button"
        disabled={submitting}
        onClick={() => vote(true)}
        className="p-1.5 rounded-lg border border-transparent hover:border-green-500/40 hover:bg-green-100 dark:hover:bg-green-900/30 disabled:opacity-50"
        aria-label="Evet, faydalı"
      >
        <ThumbsUp size={18} className="text-green-600" />
      </button>
      <button
        type="button"
        disabled={submitting}
        onClick={() => vote(false)}
        className="p-1.5 rounded-lg border border-transparent hover:border-red-500/40 hover:bg-red-100 dark:hover:bg-red-900/30 disabled:opacity-50"
        aria-label="Hayır, faydalı değil"
      >
        <ThumbsDown size={18} className="text-red-500" />
      </button>
    </div>
  );
};

export default HelpfulFeedback;
